// extracted by mini-css-extract-plugin
export default {"error":"E28zm","error__text":"bAPpv"};